// @flow
import React, { useCallback } from "react";

type Props = {
    className: string,
    handleToggle: (index: number) => void,
    index: number,
    activeRows: Array<number>,
};

const style = {
    height: "15px",
    width: "15px",
    padding: 0,
    verticalAlign: "top",
    marginBottom: 0,
    marginLeft: 0,
};

const input = {
    margin: 0,
    height: "15px",
    width: "15px",
    cursor: "pointer",
};

const stopPropagation = (e) => {
    e.stopPropagation();
};

const Checkbox = ({ className, handleToggle, index, isSelected }: Props) => {
    const handleChange = useCallback(
        (e) => {
            handleToggle(index);
        },
        [handleToggle, index]
    );
    return (
        <label
            className={className}
            onClick={stopPropagation}
            onDoubleClick={stopPropagation}
            style={style}
        >
            <input
                style={input}
                type="checkbox"
                onChange={handleChange}
                checked={isSelected(index)}
            />
        </label>
    );
};

Checkbox.displayName = "MultiSelection.Checkbox";

export default Checkbox;
